import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type OriginType = {
  x: number;
  y: number;
} | null;

const dimensionsInitialState = {
  bettingGridScale: null,
  bettingGridHeight: null,
  bettingGridWidth: null,
  bettingGridLeft: null,
  bettingGridTop: null,
  bettingGridShift: null,
  betSpotSize: null,
  leftControlsBottom: null,
  gameGridHeight: null,
  controlsOffsetBottom: null,
  contentOffsetTop: null,
  wideChipStackHeight: null,
  wideChipStackWidth: null,
  wideChipStackControlWingHeight: null,
  wideChipStackControlWingBottom: null,
  wideChipStackStep: null,
  streamHeight: null,
  streamWidth: null,
  streamViewableHeight: null,
  playAreaHeight: null,
  gameGridWrapperHeight: null,
} as const;

export type DimensionsType = keyof typeof dimensionsInitialState;

const initialState: {
  dimensions: Record<DimensionsType, number | null>;
  origins: {
    streamOrigin: OriginType;
  };
  hoverActiveNumber: number
} = {
  dimensions: dimensionsInitialState,
  origins: {
    streamOrigin: null,
  },
  hoverActiveNumber: 0
};

export const mwGameGridSlice = createSlice({
  name: 'mwGameGrid',
  initialState,
  reducers: {
    setDimensions: (state, action: PayloadAction<{ [x in DimensionsType]?: number | null }>) => {
      state.dimensions = { ...state.dimensions, ...action.payload };
    },
    updateDimensions: (state, action: PayloadAction<{ [x in DimensionsType]?: number | null }>) => {
      state.dimensions = { ...state.dimensions, ...action.payload };
    },
    handleStreamResize: (state, action: PayloadAction<{ height: number; width: number; origin: OriginType }>) => {
      state.origins.streamOrigin = action.payload.origin;
      state.dimensions.streamHeight = action.payload.height;
      state.dimensions.streamWidth = action.payload.width;
    },
    setStreamViewableHeight: (state, action: PayloadAction<number>) => {
      state.dimensions.streamViewableHeight = action.payload;
    },
    setHoverActiveNumber: (state, action: PayloadAction<{activeNumber: number}>) => {
      state.hoverActiveNumber = action.payload.activeNumber
    },
  },
});

export const mwGameGridActions = mwGameGridSlice.actions;
